export default __webpack_public_path__ + "static/media/Error.a985c7dc.svg";